import { render, staticRenderFns } from "./CommonServiceModal.vue?vue&type=template&id=88fa3a7e"
import script from "./CommonServiceModal.vue?vue&type=script&lang=js"
export * from "./CommonServiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports